<div class="versions-container width-versions-container">
    <button class="nav-link dropdown-toggle item-versions" id="versions-menu" data-bs-toggle="dropdown"
        aria-expanded="false" aria-label="Versiones del CDN">
        <span class="text-2">
            <span class="cdn-gov-co">BDC_GOV.CO </span>
            V.5
        </span>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
            class="bi bi-chevron-down" viewBox="0 0 16 16">
            <path fill-rule="evenodd"
                d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
            class="bi bi-chevron-up" viewBox="0 0 16 16">
            <path fill-rule="evenodd"
                d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z" />
        </svg>
    </button>
    <div id="versions" class="dropdown-menu dropdown-menu-versions width-versions-container"
        aria-labelledby="versions-menu">
        <ul>
            <li *ngFor="let version of versions">
                <a class="dropdown-item  item-versions" [href]="version.url" target="_blank">
                    <span>
                        <span class="text-2">BDC_GOV.CO {{ version.version }}</span>
                    </span>
                </a>
            </li>
        </ul>
    </div>
</div>
